import {
  getDateWithHumanReadableTime,
  TableView,
  useBrands,
  useCrmCustomers,
  useLoginContext,
  useModalContext,
  useUsers,
} from "common";
import { GrNotes } from "react-icons/gr";
import {
  ChangeFollowUpDate,
  InvoiceView,
  Notes,
  PoView,
  PricesheetDownloads,
  SoView,
} from "../CustomerBrandView";
import { TableNoteView } from "../common";

const FollowUpList = () => {
  const users = useUsers();
  const { isCrmAdmin } = useLoginContext();
  const { brands } = useBrands();
  const { crmCustomers } = useCrmCustomers();
  const { setModalContent } = useModalContext();

  return (
    <TableView
      url="/crmCustomerBrandList"
      tableConfig={[
        {
          name: "customer",
          header: "Customer",
        },
        {
          name: "brand",
          header: "Brand",
        },
        {
          name: "status",
          header: "Status",
        },
        {
          name: "latestSaleOrder",
          header: "Latest SO",
        },
        {
          name: "latestPurchaseOrder",
          header: "Latest PO",
        },
        {
          name: "latestInvoice",
          header: "Latest Invoice",
        },
        {
          name: "followUpDate",
          header: "Follow Up",
          type: "action",
          Component: ({ row, reloadTable }) => (
            <ChangeFollowUpDate
              brand={row}
              inline
              updateCustomerBrandState={() => reloadTable()}
            />
          ),
        },
        {
          name: "latestNote",
          header: "Latest Note",
        },
        {
          name: "notes",
          header: "",
        },
        {
          name: "pricesheetDownloads",
          header: "",
        },
      ]}
      defaultFilters={{
        followUpDate: { $exists: true },
      }}
      defaultParams={{
        populate: JSON.stringify([
          { path: "customer", select: "CustomerName" },
          { path: "brand", select: "name" },
          "latestSaleOrder",
          "latestPurchaseOrder",
          "latestInvoice",
          { path: "notes", populate: "user" },
          { path: "pricesheetDownloads", populate: "user" },
        ]),
      }}
      header="Follow Ups"
      filterConfig={[
        {
          name: "brand",
          label: "Brand",
          type: "dropdown",
          options: brands,
        },
        {
          name: "customer",
          label: "Customer",
          type: "dropdown",
          options: crmCustomers,
        },
        ...(isCrmAdmin
          ? [
              {
                name: "salesRep",
                label: "Sales Rep",
                type: "dropdown",
                options: users,
              },
            ]
          : []),
        {
          name: "followUpDate",
          label: "Follow Up Date",
          type: "daterange",
        },
      ]}
      initialSort="-followUpDate"
      shapeData={(d, reloadTable) =>
        d.data.data.map((cust) => {
          return {
            ...cust,
            customer: cust.customer?.CustomerName,
            brand: cust.brand?.name,
            latestSaleOrder: <SoView so={cust.latestSaleOrder} inline />,
            latestPurchaseOrder: (
              <PoView po={cust.latestPurchaseOrder} inline />
            ),
            latestInvoice: <InvoiceView invoice={cust.latestInvoice} inline />,
            followUpDate: getDateWithHumanReadableTime(cust.followUpDate),
            latestNote: <TableNoteView notes={cust.notes} />,
            notes: (
              <GrNotes
                cursor="pointer"
                onClick={() =>
                  setModalContent(
                    <div
                      style={{
                        width: "400px",
                        height: "500px",
                        overflow: "auto",
                      }}
                    >
                      <Notes
                        brand={cust}
                        updateCustomerBrandState={reloadTable}
                      />
                    </div>
                  )
                }
              />
            ),
            pricesheetDownloads: <PricesheetDownloads brand={cust} />,
          };
        })
      }
    />
  );
};

export default FollowUpList;
